import React from 'react';
import { SetPasswordModal } from '../../../account/set-password-modal/SetPasswordModal';
import { snakeToCamel } from '../../../caseUtils';
import { withModal, WithModalProps } from '../../../components/modal/withModal';
import {
  SignUpPhoneModal,
  FROM_PHONE_MODAL_TO_SETTINGS_PARAM,
} from '../../../signup/signup-phone-modal/SignUpPhoneModal';
import { withUser } from '../../../user/UserContext';
import { UserContextType } from '../../../user/user.types';
import { SignUpValidationModal } from '../../../signup/signup-validation/SignUpValidationModal';
import { AUTOMATIC_SIGNUP_VALIDATION_URL } from '../../../../../shared/constants/urlConstants';
import {
  withLoginModal,
  WithLoginModalProps,
} from '../../../login/withLoginModal';

/* eslint-disable camelcase */
interface CustomWindow extends Window {
  password_reset_data: {
    password_reset_code: string;
    user_id: number;
    email: string;
  };
}
/* eslint-enable camelcase */

declare let window: CustomWindow;

type Props = UserContextType & WithModalProps & WithLoginModalProps;

export class RawGlobalModalesWizard extends React.Component<Props> {
  componentDidMount() {
    // open modal on load
    const { currentUser, openModal, loggedIn, openLoginModal } = this.props;
    const passwordResetData = snakeToCamel(window.password_reset_data);
    const showLoginModal = window.show_login_modal;
    const shouldDisplaySignUpValidation = window.location.pathname.includes(
      AUTOMATIC_SIGNUP_VALIDATION_URL,
    );

    if (
      currentUser &&
      currentUser.askPhoneNumber &&
      !window.location.search.includes(FROM_PHONE_MODAL_TO_SETTINGS_PARAM)
    ) {
      openModal(modalProps => <SignUpPhoneModal {...modalProps} />);
    } else if (passwordResetData) {
      openModal(modalProps => (
        <SetPasswordModal
          passwordResetData={passwordResetData}
          {...modalProps}
        />
      ));
    } else if (!loggedIn && showLoginModal) {
      openLoginModal('automatic');
    } else if (shouldDisplaySignUpValidation) {
      openModal(modalProps => <SignUpValidationModal {...modalProps} />);
    }
  }

  render() {
    return null;
  }
}

export const GlobalModalesWizard = withLoginModal(
  withUser(withModal(RawGlobalModalesWizard)),
);
